module.exports = __webpack_public_path__ + "static/home_shoot_photo-5a080d9bc385a77b0fed7d3db0aaaef0.jpg";